import { render } from "./MazSelectInput.vue?vue&type=template&id=c09472d0&ts=true&lang=pug"
import script from "./MazSelectInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./MazSelectInput.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__